import {
  ApplicationListView,
  isPendingViewEnabled,
} from "../../config/pendingApplicationView";

type ApplicationListViewToggleProps = {
  view: ApplicationListView;
  onChange: (view: ApplicationListView) => void;
};

/**
 * The button beside a reviewer list's filter and search. In the pending view
 * it offers "Show All Applications"; in the full list it offers "Show Pending
 * Applications". Hidden when the pending view is switched off.
 */
const ApplicationListViewToggle = ({
  view,
  onChange,
}: ApplicationListViewToggleProps) => {
  if (!isPendingViewEnabled()) return null;

  const showingPending = view === "pending";

  return (
    <button
      type="button"
      className="px-4 py-3 bg-white border border-[#968f8f] rounded-xl flex justify-center items-center gap-2 text-primary font-semibold whitespace-nowrap"
      onClick={() => onChange(showingPending ? "all" : "pending")}
    >
      <i className={`fa ${showingPending ? "fa-list" : "fa-hourglass-half"} m-0`} />
      {showingPending ? "Show All Applications" : "Show Pending Applications"}
    </button>
  );
};

export default ApplicationListViewToggle;
